import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import NavBarBottom from "./NavBarBottom";
import styles from "./Header.module.scss";
import serviceLogo from "../../assets/img/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "../../redux/hooks";
import { AuthStatus, getAuthStatus } from "../../redux/reducers/auth";
import SonicLink from "../routing/SonicLink";
import { sendEventTracking } from "../../utils/GeneralUtils";

const HeaderContainer: React.FC = () => {
  const location = useLocation();

  const auth_status = useAppSelector(getAuthStatus);

  if (
    // Don't render on admin pages. This is a bad way to do this.
    location.pathname.includes("jikei") ||
    location.pathname.includes("admin")
  ) {
    return null;
  } else {
    return (
      <Header
        isLoggedIn={auth_status == AuthStatus.Authenticated ? true : false}
      />
    );
  }
};

export default HeaderContainer;

type Props = {
  isLoggedIn: boolean;
};

export const Header: React.FC<Props> = ({ isLoggedIn }) => {
  const { t } = useTranslation();

  return (
    <header className={styles["g-header"]}>
      <div className={styles["g-header__padding"]} />
      <div className={styles["g-header__wrapper"]}>
        <SonicLink to="/" className={styles["g-header__logobox"]}>
          <h1 className={styles["g-header__logo"]}>
            <img src={serviceLogo} alt="eスポーツ SELeCT" />
          </h1>
        </SonicLink>
        <div className={styles["g-header__navbox"]}>
          <SonicLink
            to="/info/service/"
            hash="#company"
            className={`${styles["g-header__link"]} ${styles["company"]}`}
            onClick={() =>
              sendEventTracking("click", "ServicePage", "toCompany")
            }
          >
            <span>企業の方はこちら</span>
          </SonicLink>
          {isLoggedIn ? null : (
            <SonicLink to="/register" className={styles["g-header__link"]}>
              <FontAwesomeIcon
                icon={["fal", "user-plus"]}
                className={`${styles["g-header__icon"]} ${styles["regist"]}`}
              />
              <span>{t("会員登録")}</span>
            </SonicLink>
          )}
          <SonicLink to="/info/service" className={styles["g-header__link"]}>
            <FontAwesomeIcon
              icon={["fal", "question-circle"]}
              className={styles["g-header__icon"]}
            />
            <span>{t("SELeCTとは？")}</span>
          </SonicLink>
          <SonicLink to="/info/guide" className={styles["g-header__link"]}>
            <FontAwesomeIcon
              icon={["fal", "book-reader"]}
              className={styles["g-header__icon"]}
            />
            <span>{t("ご利用ガイド")}</span>
          </SonicLink>
        </div>
        <NavBarBottom isLoggedIn={isLoggedIn} />
      </div>
    </header>
  );
};
